import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase} from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import UnityLogo from "../assets/images/company-logos/unity-technologies-logo-transparent.png";
import PokemonLogo from "../assets/images/company-logos/The_Pokemon_Company_International_Logo.jpg";
import EFinancialLogo from "../assets/images/company-logos/eFIN_logo.png";
//import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="May 2025 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Contract Software Development Engineer in Test</h3>
            <p>
              • Designed and built StormCore - A mini-engine and framework inside of Godot that decouples game code from the plugins needed to use them.<br/>
              * Designed and built my personal website (kaylinnormanslack.com), using TypeScript and React. Ensured quality of the site by utilizing test driven development techniques in order to ensure a proper user experience.<br/>
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Dec 2022 - May 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <img src={PokemonLogo} alt="PokemonLogo" className="company-logo"/>
            <h3 className="vertical-timeline-element-title">Software Development Engineer in Test II</h3>
            <h4 className="vertical-timeline-element-subtitle">Bellevue, WA</h4>
            <p>
                * Remediated two misarchitected test projects by migrating from Mabl to Selenium, correcting fundamental frontend-tool misapplication against backend and account recovery systems. <br/>
                * Designed and executed test coverage for the Account Recovery frontend system, validating password reset, account access restoration, and user-facing recovery workflows. <br/>
                * Contributed to CI/CD pipeline stability through rigorous backend testing practices, reducing downstream defect discovery rates.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Mar 2022 - Dec 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <img src= {UnityLogo} className="company-logo" alt="Unity Logo"/>
            <h3 className="vertical-timeline-element-title">Sr. Software Development Engineer in Test</h3>
            <h4 className="vertical-timeline-element-subtitle">Bellevue, WA</h4>
            <p>
                * Designed and maintained automation frameworks supporting backend services and platform workflows, with emphasis on API-first testing, validation testing, and outcome verification.<br/>
                * Focused on system correctness across data ingestion, processing, and downstream consumers, ensuring results delivered to users were accurate, reliable, and meaningful.<br/>
                * Partnered closely with engineers and stakeholders during system design to improve testability, observability, and long-term maintainability.<br/>
                * Contributed to shared testing infrastructure and standards used across teams, helping scale automation without creating maintenance burden.
            </p>
          </VerticalTimelineElement>
          
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Oct 2021 - Mar 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <img src={PokemonLogo} alt="PokemonLogo" className="company-logo"/>
            <h3 className="vertical-timeline-element-title">Software Test Engineer II</h3>
            <h4 className="vertical-timeline-element-subtitle">Bellevue, WA</h4>
            <p>
              * Executed functional, regression, and user acceptance testing across enterprise web applications and backend services.<br/>
              * Collaborated with managers, engineering, QA, and business stakeholders during UAT cycles to ensure features satisfied business requirements and were ready for production release .<br/>
              * Investigated defects, documented findings, and collaborated with engineering teams through verification and re-testing.<br/>
              *  Validated end-to-end workflows across multiple browsers and environments to ensure production readiness.<br/>
              * Used automation to supplement regression coverage while maintaining high-quality manual validation.
            </p>
          </VerticalTimelineElement>
          
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Dec 2019 -  Oct 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <img src={PokemonLogo} alt="PokemonLogo" className="company-logo"/>
            <h3 className="vertical-timeline-element-title">Software Test Engineer I</h3>
            <h4 className="vertical-timeline-element-subtitle">Bellevue, WA</h4>
            <p>
              * Introduced Agile testing principles to the team, improving alignment between testing, development, and product stakeholders.<br/>
              * Applied a user-empathy and UX-aware testing mindset to identify issues beyond functional correctness, helping teams better understand real user interaction patterns.<br/>
              * Learned and applied UI automation practices under mentorship, contributing to the expansion of automated test coverage.<br/>
              * Helped integrate Mabl into the testing workflow, enabling stronger collaboration with marketing teams and supporting data-driven improvements to user-facing sites.<br/>
              * Proposed a secure image-loading API concept to improve performance and reliability, which later informed foundational frameworks still in use within the organization.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Dec 2019 -  Oct 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <img src={EFinancialLogo} alt="eFinancialLogo" className="company-logo"/>
            <h3 className="vertical-timeline-element-title">Software Test Engineer I</h3>
            <h4 className="vertical-timeline-element-subtitle">Renton, WA</h4>
            <p>
              * Initially supported engineering teams in a development-support capacity, troubleshooting issues across environments and assisting with system reliability.<br/>
              * Transitioned into a software testing role to address team needs, rapidly learning testing fundamentals and applying them in a production environment.<br/>
              * Designed and executed manual and exploratory test scenarios to validate system behavior and identify defects early in the development cycle.<br/>
              * Applied Agile testing principles, collaborating closely with developers and product stakeholders to improve communication and test coverage.<br/>
              * Demonstrated strong adaptability and learning velocity, successfully shifting responsibilities under tight timelines while maintaining quality expectations.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
